<div class="resource-cards-container" [ngClass]="{ 'mobile-resource-cards-container': isMobileApp , 'ccu-resource-cards-container': isCCU }">

    @for (resource of resourceCards; track resource.link) {
    <div class="video-card" (click)="openLink(resource.link)">
        <div class="vc-thumb">
            <!-- Thumbnail exists for video links-->
            @if (resource?.thumbnailUrl && resource.type == 'video') {
            
            <img [src]="resource.thumbnailUrl" [alt]="resource.title" loading="lazy" />
            <div class="vc-play-circle">
                <!-- play svg -->
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M20 2.5C15.3587 2.5 10.9075 4.34374 7.62563 7.62563C4.34374 10.9075 2.5 15.3587 2.5 20C2.5 24.6413 4.34374 29.0925 7.62563 32.3744C10.9075 35.6563 15.3587 37.5 20 37.5C24.6413 37.5 29.0925 35.6563 32.3744 32.3744C35.6563 29.0925 37.5 24.6413 37.5 20C37.5 15.3587 35.6563 10.9075 32.3744 7.62563C29.0925 4.34374 24.6413 2.5 20 2.5ZM29.7525 20L15 10.165V29.835L29.7525 20Z"
                        fill="currentColor" />
                    <path d="M15 10.1641L29.7525 19.9991L15 29.8341V10.1641Z" fill="white" />
                </svg>
            </div>
            }
            <!-- Thumbnail exists for citation links-->
            @else if (resource?.thumbnailUrl && resource.type == 'citation') {
            <img [src]="resource.thumbnailUrl" [alt]="resource.title" loading="lazy" />
            }
            
            <!-- Fallback when no thumbnail -->
            @else {
            <div class="vc-fallback">
                <img [src]="defaultThumbnailPath" [alt]="'default thumbnail'" loading="lazy" />
            </div>
            }
        </div>

        <div class="vc-body">
            <p class="vc-title">
                {{ resource.title }}
            </p>
            <p class="vc-source">
                {{ resource.host }}
            </p>
        </div>
    </div>
    }
</div>